import {html, LitElement} from 'lit';

import '@polymer/app-layout/app-toolbar/app-toolbar'

export default class TtBuildInfo extends LitElement {
    static get properties() {
        return {
            config: {
                type: Object,
                value: function () {
                    return GLOB;
                }
            }
        };
    }

    render() {
        return html`
<app-toolbar>Config</app-toolbar>
<ul style="list-style: none;">
    <li>MODE: ${BUILD_CONTEXT.mode}</li>
    <li>SHA: ${BUILD_CONTEXT.sha}</li>
    <li>SOURCE: ${BUILD_CONTEXT.source}</li>
    <li>API: ${BUILD_CONTEXT.api}</li>
    <li>FIREBASE: ${BUILD_CONTEXT.firebase}</li>
    <li>SENTRY: ${BUILD_CONTEXT.sentry}</li>
    <li>AUTH: ${BUILD_CONTEXT.auth}</li>
    
    <li><a href="https://grafana.int.tt-news.de/explore?schemaVersion=1&panes=%7B%22mxa%22:%7B%22datasource%22:%22P8E80F9AEF21F6940%22,%22queries%22:%5B%7B%22refId%22:%22A%22,%22expr%22:%22%7Bcontainer%3D%5C%22ticker-backend%5C%22%7D%22,%22queryType%22:%22range%22,%22datasource%22:%7B%22type%22:%22loki%22,%22uid%22:%22P8E80F9AEF21F6940%22%7D,%22editorMode%22:%22builder%22%7D%5D,%22range%22:%7B%22from%22:%22now-1h%22,%22to%22:%22now%22%7D%7D%7D&orgId=1" target="_blank">Logs</a></li>
    <li><a href="https://console.cloud.google.com/cloudtasks?inv=1&invt=AbmCRQ&project=tt-news-ae9e0e5e" target="_blank">Queue</a></li>
</ul>
`;
    }

}

window.customElements.define('tt-build-info', TtBuildInfo);
